/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/no-unescaped-entities */
import React from 'react'
// import { FaPlus } from 'react-icons/fa'
// import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Breadcrumb from '../components/Breadcrumb'
import FooterFour from '../components/Footer'
import Navbar from '../components/Navbar'

const Terms = () => {
  const { t } = useTranslation()
  const terms = t('terms-&-conditions', { returnObjects: true })

  // const industries = t('about-us-industries', { returnObjects: true })

  return (
    <React.Fragment>
      <Navbar />
      <Breadcrumb title="terms-and-conditions" />
      {/* =============== Terms & Conditions Area ===============*/}
      <div className="container terms">
        <h2>{t(terms.interpretation_title)}</h2>
        <h3>{t(terms.interpretation_subtitle)}</h3>
        <p>{t(terms.interpretation_paragraph)}</p>
        <h2>{t(terms.definitions_title)}</h2>
        <h3>{t(terms.definitions_subtitle)}</h3>
        <ul className="mx-4">
          <li>
            <p dangerouslySetInnerHTML={{ __html: t(terms.affiliate) }}></p>
          </li>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t(terms.country) }}></p>
          </li>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t(terms.company) }}></p>
          </li>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t(terms.device) }}></p>
          </li>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t(terms.service) }}></p>
          </li>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t(terms.terms) }}></p>
          </li>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t(terms.third_party) }}></p>
          </li>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t(terms.website) }}></p>
          </li>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t(terms.you) }}></p>
          </li>
        </ul>
        <h2>{t(terms.acknowledgment_title)}</h2>
        <p>{t(terms.acknowledgment_paragraph1)}</p>
        <p>{t(terms.acknowledgment_paragraph2)}</p>
        <p>{t(terms.acknowledgment_paragraph3)}</p>
        <p>{t(terms.acknowledgment_paragraph4)}</p>
        <p>{t(terms.acknowledgment_paragraph5)}</p>
        <h2>{t(terms.links_to_other_websites_title)}</h2>
        <p>{t(terms.links_to_other_websites_paragraph1)}</p>
        <p>{t(terms.links_to_other_websites_paragraph2)}</p>
        <p>{t(terms.links_to_other_websites_paragraph3)}</p>
        <h2>{t(terms.termination_title)}</h2>
        <p>{t(terms.termination_paragraph1)}</p>
        <p>{t(terms.termination_paragraph2)}</p>
        <h2>{t(terms.limitation_of_liability_title)}</h2>
        <p>{t(terms.limitation_of_liability_paragraph1)}</p>
        <p>{t(terms.limitation_of_liability_paragraph2)}</p>
        <p>{t(terms.limitation_of_liability_paragraph3)}</p>
        <h2>{t(terms.as_is_and_as_available_disclaimer_title)}</h2>
        <p>{t(terms.as_is_and_as_available_disclaimer_paragraph1)}</p>
        <p>{t(terms.as_is_and_as_available_disclaimer_paragraph2)}</p>
        <p>{t(terms.as_is_and_as_available_disclaimer_paragraph3)}</p>
        <h2>{t(terms.Governing_law_title)}</h2>
        <p>{t(terms.Governing_law)}</p>
        <h2>{t(terms.Disputes_resolution_title)}</h2>
        <p>{t(terms.Disputes_resolution)}</p>
        <h2>{t(terms.For_european_union_title)}</h2>
        <p>{t(terms.For_european_union)}</p>
        <h2>{t(terms.United_states_legal_title)}</h2>
        <p>{t(terms.United_states_legal_compliance)}</p>
        <h2>{t(terms.Severability_and_waiver_title)}</h2>
        <h3>{t(terms.Severability)}</h3>
        <p>{t(terms.Severability_and_waiver)}</p>
        <h3>{t(terms.waiver)}</h3>
        <p>{t(terms.waiver_paragraph)}</p>
        <h2>{t(terms.Translation_interpretation_title)}</h2>
        <p>{t(terms.Translation_interpretation)}</p>
        <h2>{t(terms.Changes_to_these_title)}</h2>
        <p>{t(terms.Changes_to_these)}</p>
        <p>{t(terms.by_continuing)}</p>
        <h2>{t('contactus')}</h2>
        <p>{t(terms.Contact_Us)}</p>
        <ul className="align-self-center terms-email">
          <li>
            By email:{' '}
            <a href="mailto:info@axissoftsolutions.com">
              info@axissoftsolutions.com
            </a>
          </li>
        </ul>
        <br />
        <br />
      </div>

      {/* =============== Terms & Conditions Area ===============*/}
      <FooterFour />
    </React.Fragment>
  )
}

export default Terms
